const COMPONENT_NAME = "TextBuilder";
const CATEGORY_LANDING_PAGE_SETTINGS_DEVELOPER_KEY = "category_landing_page";
export {
  CATEGORY_LANDING_PAGE_SETTINGS_DEVELOPER_KEY,
  COMPONENT_NAME
};
